module.exports = __webpack_public_path__ + "static/assets/0e235c63adddfa3a1371329888b05508.png";